<template>
  <div :class="containerClass" @click="onWrapperClick">
    <AppTopBar @menu-toggle="onMenuToggle"/>

    <transition name="layout-sidebar">
      <div :class="sidebarClass" @click="onSidebarClick" v-show="isSidebarVisible()">
        <div class="layout-logo">
          <router-link to="/">
            <img alt="Logo" :src="logo"/>
          </router-link>
        </div>

        <AppProfile/>
        <AppMenu :model="menu" @menuitem-click="onMenuItemClick"/>
      </div>
    </transition>

    <div class="layout-main">
      <fullscreen :fullscreen.sync="fullscreen">
        <router-view/>
      </fullscreen>
      <!-- <button class="p-link" @click="onToggleScreen">
        <span v-if="!staticMenuInactive && layoutMode === 'static'"
              class="layout-topbar-icon pi pi-window-maximize fullscreen-button"></span>
      </button> -->
    </div>

    <AppConfig :layoutMode="layoutMode" @layout-change="onLayoutChange" @layout-color-change="onLayoutColorChange"/>

    <AppFooter/>

  </div>

</template>

<script>
  import AppTopBar from '../AppTopbar.vue';
  import AppProfile from '../AppProfile.vue';
  import AppMenu from '../AppMenu.vue';
  import AppConfig from '../AppConfig.vue';
  import AppFooter from '../AppFooter.vue';
  import UserService from '../services/UserService';

  export default {
    data() {
      return {
        fullscreen: false,
        layoutMode: 'static',
        layoutColorMode: this.$store.state.theme,
        staticMenuInactive: false,
        overlayMenuActive: false,
        mobileMenuActive: false,
        menu: [],
        defined_menu: [
          {label: 'Dashboard', icon: 'pi pi-fw pi-home', to: '/dashboard', accesses: null},
          {
            label: 'Report', icon: 'pi pi-fw pi-table',
            items: [
              {label: 'Car Parks', icon: 'pi pi-fw pi-table', to: '/report-carpark'},
              {label: 'Clients', icon: 'pi pi-fw pi-table', to: '/report-client'},
              {label: 'Customers', icon: 'pi pi-fw pi-table', to: '/report-customer'},
              {label: 'Daily report', icon: 'pi pi-fw pi-table', to: '/report-daily'},
            ],
            accesses: ['view_client', 'view_charity', 'admin']
          },
          {
            label: 'Client', icon: 'pi pi-fw pi-sitemap',
            items: [
              {label: 'Clients', icon: 'pi pi-fw pi-table', to: '/clients'},
            ],
            accesses: ['view_client', 'admin']
          },
          {
            label: 'Car Park', icon: 'pi pi-fw pi-sliders-v',
            items: [
              {label: 'Car Parks', icon: 'pi pi-fw pi-table', to: '/carparks'},
            ],
            accesses: ['admin']
          },
          {
            label: "Charity", icon: 'pi pi-fw pi-globe',
            items: [
              {label: 'Charities', icon: 'pi pi-fw pi-table', to: '/charities'},
            ],
            accesses: ['view_charity', 'admin']
          },
          {
            label: 'Access Management', icon: 'pi pi-fw pi-key',
            items: [
              {label: 'Users', icon: 'pi pi-fw pi-users', to: '/user'},
              {label: 'Roles', icon: 'pi pi-fw pi-lock', to: '/role'},
            ],
            accesses: ['admin']
          },
          // {
          //   label: 'Setting', icon: 'pi pi-fw pi-cog',
          //   items: [
          //     {label: 'Cities', icon: 'pi pi-fw pi-th-large', to: '/cities'},
          //   ],
          //   accesses: ['admin']
          // }
          // {
          //   label: 'Calandar', icon: 'pi pi-fw pi-calendar-plus', command: () => {
          //     window.location = "#/calendar"
          //   }
          // },
        ]
      }
    },
    userService: null,
    created() {
      this.userService = new UserService();
    },
    watch: {
      $route() {
        this.menuActive = false;
        this.$toast.removeAllGroups();
      }
    },
    methods: {
      menuObject() {
        let user_info = this.$store.state.user_info ? JSON.parse(this.$store.state.user_info) : {};
        this.userService.getUserAccesses(user_info.id).then(result => {
          if (result.status === 200) {
            let accesses = result.data.accesses;
            this.menu = this.defined_menu.filter(item => this.userService.hasAccess(accesses, item.accesses));
            this.$store.state.accesses = accesses;
          }
        });
      },
      onToggleScreen() {
        this.fullscreen = !this.fullscreen
      },
      onWrapperClick() {
        if (!this.menuClick) {
          this.overlayMenuActive = false;
          this.mobileMenuActive = false;
        }

        this.menuClick = false;
      },
      onMenuToggle() {
        this.menuClick = true;

        if (this.isDesktop()) {
          if (this.layoutMode === 'overlay') {
            if (this.mobileMenuActive === true) {
              this.overlayMenuActive = true;
            }

            this.overlayMenuActive = !this.overlayMenuActive;
            this.mobileMenuActive = false;
          } else if (this.layoutMode === 'static') {
            this.staticMenuInactive = !this.staticMenuInactive;
          }
        } else {
          this.mobileMenuActive = !this.mobileMenuActive;
        }

        event.preventDefault();
      },
      onSidebarClick() {
        this.menuClick = true;
      },
      onMenuItemClick(event) {
        if (event.item && !event.item.items) {
          this.overlayMenuActive = false;
          this.mobileMenuActive = false;
        }
      },
      onLayoutChange(layoutMode) {
        this.layoutMode = layoutMode;
      },
      onLayoutColorChange(layoutColorMode) {
        this.layoutColorMode = layoutColorMode;
        let theme = this.layoutColorMode === 'light' ? "light" : "dark";
        let htmlElement = document.documentElement;
        htmlElement.setAttribute('theme', theme);
        localStorage.setItem("theme", theme);
        this.$store.state.theme = theme;
      },
      addClass(element, className) {
        if (element.classList)
          element.classList.add(className);
        else
          element.className += ' ' + className;
      },
      removeClass(element, className) {
        if (element.classList)
          element.classList.remove(className);
        else
          element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
      },
      isDesktop() {
        return window.innerWidth > 1024;
      },
      isSidebarVisible() {
        if (this.isDesktop()) {
          if (this.layoutMode === 'static')
            return !this.staticMenuInactive;
          else if (this.layoutMode === 'overlay')
            return this.overlayMenuActive;
          else
            return true;
        } else {
          return true;
        }
      },
    },
    computed: {
      containerClass() {
        return ['layout-wrapper', {
          'layout-overlay': this.layoutMode === 'overlay',
          'layout-static': this.layoutMode === 'static',
          'layout-static-sidebar-inactive': this.staticMenuInactive && this.layoutMode === 'static',
          'layout-overlay-sidebar-active': this.overlayMenuActive && this.layoutMode === 'overlay',
          'layout-mobile-sidebar-active': this.mobileMenuActive,
          'p-input-filled': this.$appState.inputStyle === 'filled',
          'p-ripple-disabled': this.$primevue.ripple === false,
          'layout-dark': this.$store.state.theme === 'dark',
          'layout-light': this.$store.state.theme === 'light'
        }];
      },
      sidebarClass() {
        return ['layout-sidebar', {
          'layout-sidebar-dark': this.$store.state.theme === 'dark',
          'layout-sidebar-light': this.$store.state.theme === 'light'
        }];
      },
      logo() {
        return (this.$store.state.theme === 'dark') ? "../assets/layout/images/logo/logo.svg" : "../assets/layout/images/logo/logo.svg";
      }
    },
    mounted() {
      let theme = localStorage.getItem("theme") === 'dark' ? "dark" : "light";
      let htmlElement = document.documentElement;
      htmlElement.setAttribute('theme', theme);
      this.$store.state.theme = theme;
      this.menuObject();
    },
    beforeUpdate() {
      if (this.mobileMenuActive)
        this.addClass(document.body, 'body-overflow-hidden');
      else
        this.removeClass(document.body, 'body-overflow-hidden');
    },
    components: {
      'AppTopBar': AppTopBar,
      'AppProfile': AppProfile,
      'AppMenu': AppMenu,
      'AppConfig': AppConfig,
      'AppFooter': AppFooter,
    }
  }
</script>

<style lang="scss">
  @import '../App.scss';
</style>
